var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Flex, Input, Modal, Typography } from '@robinpowered/ui-kit';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
export var RejectionModal = function (_a) {
    var open = _a.open, onSubmit = _a.onSubmit, onError = _a.onError, onCancel = _a.onCancel, rejectEventRequest = _a.rejectEventRequest, eventId = _a.eventId;
    var t = useTranslation('meetingRooms').t;
    var _b = __read(useState(''), 2), rejectionNote = _b[0], setRejectionNote = _b[1];
    var _c = __read(useState(false), 2), submittingRejection = _c[0], setSubmittingRejection = _c[1];
    var handleReject = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSubmittingRejection(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, rejectEventRequest(eventId, rejectionNote.trim() || undefined).then(function (res) {
                            var _a;
                            if ((res === null || res === void 0 ? void 0 : res.approved) === false) {
                                setRejectionNote('');
                                onSubmit();
                            }
                            else {
                                onError(new Error((_a = res === null || res === void 0 ? void 0 : res.approval_notes) !== null && _a !== void 0 ? _a : t('errors.failed_to_reject_event_request')));
                            }
                        })];
                case 2:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 3:
                    setSubmittingRejection(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Modal, { open: open, title: t('eventDetails.request.reject_modal_title'), okText: t('eventDetails.request.reject'), cancelText: t('eventDetails.request.cancel'), okType: "danger", onOk: handleReject, confirmLoading: submittingRejection, onCancel: onCancel, footer: [
            _jsx(Button, { onClick: onCancel, type: "text", children: t('eventDetails.request.cancel') }, "cancel"),
            _jsx(Button, { onClick: handleReject, type: "primary", danger: true, loading: submittingRejection, children: t('eventDetails.request.reject') }, "reject"),
        ], children: [_jsxs(Flex, { gap: 4, children: [_jsx(Typography.Text, { children: t('eventDetails.request.reject_modal_description') }), _jsx(Typography.Text, { type: "secondary", children: t('eventDetails.request.optional') })] }), _jsx(Input.TextArea, { rows: 4, value: rejectionNote, onChange: function (event) { return setRejectionNote(event.target.value); }, placeholder: t('eventDetails.request.reject_modal_note_placeholder'), style: { marginTop: 12 } })] }));
};
